import React from 'react';
import Table from 'react-bootstrap/Table';
import Papa from 'papaparse';
import { CSVLink } from 'react-csv';
import Button from 'react-bootstrap/Button';

import withRouter from '../../../util/WithRouter';
import DocumentAPI from '../../../api/DocumentAPI';
import ApiUiController from '../../../controller/ApiUiController';

class ImportDetails extends React.Component {

  constructor(props) {
    super(props);
    this.imports = [];
    this.state = { errordata: [], inApiCall: true };
    this.columns = [
      { dataField: 'col_0', text: 'Row No' },
      { dataField: 'col_1', text: 'CRM Request' },
      { dataField: 'col_2', text: 'CRM Status' }
    ];
    this.data = [];
  }

  componentDidMount() {
    new Promise(async resolve => {
      let res = await DocumentAPI.getPublicMediaUrl(this.props.match.params.res);
      res = await DocumentAPI.getText(res.url);
      const data = JSON.parse(res);
      res = await DocumentAPI.getPublicMediaUrl(this.props.match.params.csv);
      res = await DocumentAPI.getText(res.url);
      let csv = Papa.parse(res, { download: false, skipEmptyLines: true });
      csv = csv.data;
      const errordata = [[...csv[0], 'Error']];
      for(let i = 0; i < data.length; i++) {
        if(data[i].failure) {
          errordata.push([...csv[i + 1], `"${JSON.stringify(data[i])}"`]);
        }
      }
      resolve({ data, csv, errordata });
    }).then(res => {
      this.data = res.data;
      this.csv = res.csv;
      this.setState({ ...this.state, errordata: res.errordata, inApiCall: false });
    });
  }

  render() {
    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <ApiUiController inApiCall={this.props.inApiCall}>
            <div className="row">
              <div className="col-md-12">
                <CSVLink 
                  data={this.state.errordata}
                  filename={'Not Imported.csv'}
                  target="_blank">
                  <Button className="buttons btn-success">Export error data</Button>
                </CSVLink>
                <Table striped bordered hover size="lg">
                  <thead>
                    <tr>
                      <th>CSV Number</th>
                      <th>CSV Data</th>
                      <th>Response Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.data ? this.data.map((item, i) =>
                        <tr key={`import_item_${i}`}>
                          <td bgcolor={`${item.failure ? '#FF999C' : '#FFFFFF'}`}>{i + 1}</td>
                          <td>{JSON.stringify(this.csv[i + 1])}</td>
                          <td>{JSON.stringify(item)}</td>
                        </tr>
                      )
                      : null
                    }
                  </tbody>
                </Table>
              </div>
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(ImportDetails);
